<template>
<!--
  検証メッセージ。**見た目と出す順番はここだけで決める。**

  以前は <p class="preika-form-message"> を17行並べていた。色は共通CSSの属性
  セレクタ（[style*="color: red"]）が拾ってくれていたが、行間と並べ方は
  この画面のままで、段落の既定余白が積み上がって**開いた瞬間に赤が
  5行**という見た目になっていた。業務報告は欄の下に小さく出るだけで、
  同じ製品の中で別のものに見えていた。

  **文言は変えない。**囲みと色だけ、触る前と触ったあとで切り替える。
  何も入れていないうちは、どの欄も空なのが当たり前で、利用者は何も
  間違えていない。名指しはするが、赤で警告する場面ではない。
-->
<div>
  <!-- 凡例は先に出す。記号の意味を、赤を読み終えたあとで知らせない。 -->
  <p class="preika-form-legend">
    <span class="preika-required-note"><span class="preika-required-note__mark" aria-hidden="true">*</span><span>が付いている項目は必須入力項目です</span></span>
  </p>

  <div v-if="hasMessages"
       :class="untouched ? 'preika-form-notes' : 'preika-form-errors'"
       :role="untouched ? null : 'alert'">
    <p class="preika-form-message" v-for="error in rowsEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in dayEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in typeEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in projectEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in paymentEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in originEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in originMax" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in destinationEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in destinationMax" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in routeEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in routeMax" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in costEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in costRegex" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in temporaryEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in temporaryRegex" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in remarksEmpty" :key="error">{{ '※' + error }}</p>
    <p class="preika-form-message" v-for="error in remarksMax" :key="error">{{ '※' + error }}</p>
  </div>
</div>
</template>

<script>
import ConstList from './../../ConstList'

// 1行ぶんの値を読む。渡っていない列も、まだ配列に入っていない行も「空」。
//
// **配列の長さではなく rows（保存ボタンが見ている行数）で回すため**の
// 読み取り。「追加」で作った直後の行は day1 や cost の配列にまだ無く、
// 長さで回していたころは**その行の理由が1つも出ないまま保存だけが
// 止まって**いた。
function valueAt (list, i) {
  const value = (list || [])[i]
  return (value === undefined || value === null) ? '' : value
}

function textAt (list, i) {
  return String(valueAt(list, i))
}

// 行ごとのメッセージを、呼ばれるたびに rows 行ぶん作り直す。
//
// **splice で書き溜めない。**書き溜めていたころは、1行目を埋めると
// 2行目のメッセージが二重に出て（v-for の :key が重複する）、行を
// 削除しても消えた行番号のメッセージが残っていた。
//
// これらは this を使わない素の関数にしてある。メソッドの中から
// this.〜 で呼ぶと、**コンポーネントを組み立てずにメソッドだけを
// 呼ぶ検査**が動かなくなるため。
function rowMessages (rows, tailOf) {
  const messages = []
  for (let i = 0; i < rows; i++) {
    const tail = tailOf(i)
    if (tail) { messages.push(i + 1 + '行目の' + tail) }
  }
  return messages
}

export default {
  name: 'ExpenseError',
  data() {
    return {
      dayEmpty: [],
      typeEmpty: [],
      paymentEmpty: [],
      originEmpty: [],
      originMax: [],
      destinationEmpty: [],
      destinationMax: [],  
      routeEmpty: [],
      routeMax: [],
      costEmpty: [],
      costRegex: [],
      temporaryEmpty: [],
      temporaryRegex: [],
      remarksEmpty: [],
      remarksMax: []
    }
  },
  // 画面によって渡ってこない props がある（通勤費には申請区分の列が無く、
  // 仮払の有無はどちらの画面からも渡していない）。既定値を持たせないと
  // undefined のまま `type[i]` を読んで例外になり、**同じ処理の中にある
  // 年月日や金額のメッセージまで、まとめて出なくなる。**
  // 渡っていない項目は「空の列」として扱えば、その画面に関係する
  // メッセージだけが出る。
  props: {
    day1: { type: Array, default: () => [] },
    request_type: { type: Array, default: () => [] },
    payment_type: { type: Array, default: () => [] },
    origin: { type: Array, default: () => [] },
    destination: { type: Array, default: () => [] },
    route: { type: Array, default: () => [] },
    cost: { type: Array, default: () => [] },
    remarks: { type: Array, default: () => [] },
    temporary: { type: Array, default: () => [] },
    project_id: { type: Array, default: () => [] },
    // プロジェクトの選択肢。0件かどうかで出す言葉が変わる。
    project_list: { type: Array, default: () => [] },
    // 保存ボタンの判定が見ている行数。配列の長さではなくこれを見る。
    rows: { type: Number, default: 0 },
  },
  computed: {
    // 行が1つも無い状態。
    //
    // 保存ボタンは「行が0なら押させない」も条件に入れているのに、
    // その理由だけどこにも出ていなかった。**当月のデータが無い月を
    // 表示すると、空の表と死んだ保存ボタンだけが出る。**
    // 選べるプロジェクトが無いときは行を作っても意味が無いので、
    // そちらの案内（projectEmpty）に任せる。
    rowsEmpty: function () {
      if (this.rows > 0 || !this.project_list.length) {
        return []
      }
      return ['保存できる行がありません。「追加」で行を作ってください ']
    },
    // プロジェクト名の未選択。
    //
    // 保存の条件（activeButton）は project_id を必須として見ているのに、
    // 名指しするメッセージがどこにも無かった。普段は所属の先頭が既定で
    // 入るので誰も気づかず、**所属プロジェクトが取れない利用者だけ**が
    // 理由の分からないまま永久に保存できない状態になっていた。
    //
    // computed なのは、プロジェクト名の欄に @blur が無く、**何かの欄から
    // 離れるのを待っていると出せない**ため。押せない条件と同じ
    // project_id を、同じ行数だけ、その場で読み直す。
    // （他の項目も、書き溜めずに rows 行ぶん作り直す形へそろえてある）
    projectEmpty: function () {
      // 選択肢そのものが0件なら、行ごとに名指ししても利用者は直せない。
      // 当月のデータが1行も無くても出す必要がある（行が無い＝この
      // メッセージが要らない、ではない）。
      if (!this.project_list.length) {
        return ['プロジェクト管理にて、プロジェクトを設定して下さい。']
      }
      const messages = []
      for (let i = 0; i < this.rows; i++) {
        if (!this.project_id[i]) {
          messages.push(i + 1 + '行目のプロジェクト名を選択してください ')
        }
      }
      return messages
    },

    // まだ1文字も入れていない状態。
    //
    // **開いた直後を「エラーが5件ある画面」に見せない。**どの欄も空
    // なのは当たり前で、利用者はまだ何も間違えていない。名指しはする
    // が、赤で警告する場面ではない。
    //
    // プロジェクト名は見ない。**所属の先頭が既定で入っている**ので、
    // これを「入力した」と数えると、開いた瞬間に赤へ切り替わる。
    //
    // 真偽値を返す。配列を返すと、画面に出ているメッセージを数える
    // 検査（messagesOn）が同じものを二重に拾う。
    untouched: function () {
      const lists = [
        this.day1, this.request_type, this.payment_type,
        this.origin, this.destination, this.route,
        this.cost, this.remarks, this.temporary
      ]
      for (let n = 0; n < lists.length; n++) {
        for (let i = 0; i < this.rows; i++) {
          if (textAt(lists[n], i).trim() !== "") { return false }
        }
      }
      return true
    },

    // 出すものが1つでもあるか。**空の囲みを描かない。**
    //
    // これも真偽値。中身は下の v-for がそれぞれ持っている。
    hasMessages: function () {
      const groups = [
        this.rowsEmpty, this.dayEmpty, this.typeEmpty, this.projectEmpty,
        this.paymentEmpty, this.originEmpty, this.originMax,
        this.destinationEmpty, this.destinationMax,
        this.routeEmpty, this.routeMax,
        this.costEmpty, this.costRegex,
        this.temporaryEmpty, this.temporaryRegex,
        this.remarksEmpty, this.remarksMax
      ]
      for (let n = 0; n < groups.length; n++) {
        if ((groups[n] || []).length) { return true }
      }
      return false
    },
  },
  methods: {
    // 年月日の未入力。
    //
    // 保存の条件は行の中身をその場で見て無条件に必須としているので、
    // ここも「空なら出す」に合わせる。以前は**他の欄に何か入っている
    // ときだけ**出していたため、何も触っていない行は理由が出ないまま
    // 保存だけが止まっていた。
    // 見出しは「年月日」。画面に無い言葉で呼ぶと、どこを直せばよいか
    // 分からなくなる。
    day1_empty: function () {
      this.dayEmpty = rowMessages(this.rows, i =>
        textAt(this.day1, i) === "" ? '年月日を選択してください ' : "")
    },
    // 申請区分の未入力。経費だけにある列で、保存の条件も無条件に必須。
    type_empty: function () {
      this.typeEmpty = rowMessages(this.rows, i =>
        textAt(this.request_type, i) === "" ? '申請区分を選択してください ' : "")
    },
    // 仮払有り無しの空文字チェック。
    // **経費にも通勤費にもこの列は無く、どちらの画面からも呼ばれていない。**
    // 出しどころが無いので、行数で作り直す形へは寄せずに残してある。
    // 使うときは他と同じく rows で回す形に直すこと。
    payment_empty: function () {
      let error = this.paymentEmpty
      const day = this.day1
      const type = this.request_type
      const payment = this.payment_type
      const origin = this.origin
      const destination = this.destination
      const route = this.route
      const cost = this.cost
      const remarks = this.remarks
      payment.forEach((value, i, array) => {
        if (((day[i] !== "") || (type[i] !== "")|| (origin[i] !== "") || (destination[i] !== "") || (route[i] !== "") || (cost[i] !== "") || (remarks[i] !== "")) && (array[i] === "")) {
          error.splice(i, 1, i + 1 + '行目の仮払の有無を選択してください ')
        } else {
          error.splice(i, 1)
        }
      })
    },
    // (経費)出発の未入力。
    // 経費は**出張交通費のときだけ**出発と到着を必須にしている
    // （保存の条件も同じ）。到着だけ入っている行は、対になる出発が
    // 抜けているので出す。
    origin_empty: function () {
      this.originEmpty = rowMessages(this.rows, i => {
        const required = valueAt(this.request_type, i) === ConstList.TRANSPORT_ID
        const paired = textAt(this.destination, i) !== ""
        return ((required || paired) && textAt(this.origin, i) === "")
          ? '出発を入力してください ' : ""
      })
    },
    // (通勤)出発の未入力。
    //
    // 空なのは「出発」。ここが「到着」を名指ししていたため、**必ず
    // 埋まっている到着を打ち直すよう促していた。**
    //
    // 通勤費は保存の条件が無条件に出発を要るので、**到着が入っているか
    // どうかで出し分けない。**出発も到着も空の行は、以前は何も言われない
    // まま保存だけが止まっていた。
    co_origin_empty: function () {
      this.originEmpty = rowMessages(this.rows, i =>
        textAt(this.origin, i) === "" ? '出発を入力してください ' : "")
    },
    // 出発の文字数制限チェック。
    // 見出しも入力欄も「出発」。「発地」は画面のどこにも出てこない。
    origin_max: function () {
      this.originMax = rowMessages(this.rows, i =>
        textAt(this.origin, i).length > 128
          ? '出発は128文字以内で入力してください ' : "")
    },
    // (経費)到着の未入力。
    // 見出しは「到着」。「着地」では画面のどの欄か分からない。
    destination_empty: function () {
      this.destinationEmpty = rowMessages(this.rows, i => {
        const required = valueAt(this.request_type, i) === ConstList.TRANSPORT_ID
        const paired = textAt(this.origin, i) !== ""
        return ((required || paired) && textAt(this.destination, i) === "")
          ? '到着を入力してください ' : ""
      })
    },
    // (通勤)到着の未入力。出発と同じく、無条件に必須。
    co_destination_empty: function () {
      this.destinationEmpty = rowMessages(this.rows, i =>
        textAt(this.destination, i) === "" ? '到着を入力してください ' : "")
    },
    // 到着の文字数制限チェック
    destination_max: function () {
      this.destinationMax = rowMessages(this.rows, i =>
        textAt(this.destination, i).length > 128
          ? '到着は128文字以内で入力してください ' : "")
    },
    // (経費)交通機関・施設の空文字チェック。
    // 経費と通勤費で見出しが違う（経費は「交通機関・施設」、通勤費は
    // 「交通機関」）ので、同じ欄でもメソッドを分けて言葉を変える。
    route_empty: function () {
      // 保存の条件は申請区分によらず交通機関・施設を必須にしているのに、
      // ここは出張交通費と宿泊のときしか出していなかった。**申請区分が
      // 「経費」の行は、空のまま何も言われずに保存だけが止まっていた。**
      this.routeEmpty = rowMessages(this.rows, i =>
        textAt(this.route, i) === "" ? '交通機関・施設を入力してください ' : "")
    },
    // (通勤)交通機関の空文字チェック
    co_route_empty: function () {
      // 通勤費の画面に「便名」という欄は無い。見出しは「交通機関」。
      this.routeEmpty = rowMessages(this.rows, i =>
        textAt(this.route, i) === "" ? '交通機関を入力してください ' : "")
    },
    // (経費)交通機関・施設の文字数制限チェック
    route_max: function () {
      this.routeMax = rowMessages(this.rows, i =>
        textAt(this.route, i).length > 128
          ? '交通機関・施設は128文字以内で入力してください ' : "")
    },
    // (通勤)交通機関の文字数制限チェック。
    // 上限は経費と同じだが、通勤費の見出しには「・施設」が無い。
    // 画面に無い言葉で長さを注意されても、どの欄のことか分からない。
    co_route_max: function () {
      this.routeMax = rowMessages(this.rows, i =>
        textAt(this.route, i).length > 128
          ? '交通機関は128文字以内で入力してください ' : "")
    },
    // 金額の未入力。保存の条件はどちらの画面でも無条件に必須。
    cost_empty: function () {
      this.costEmpty = rowMessages(this.rows, i =>
        textAt(this.cost, i) === "" ? '金額を入力してください ' : "")
    },
    // 金額の入力形式チェック。
    //
    // カンマは3桁ごとに画面が足している見た目で、**読み込んだ直後の値には
    // まだ付いていない。**「3桁,3桁」の形しか通していなかったので、
    // カンマを外してから数字かどうかだけを見る。前の形だと
    // **開いた瞬間に金額が赤くなり、百万円以上の金額も弾かれていた。**
    cost_regex: function () {
      this.costRegex = rowMessages(this.rows, i => {
        const digits = textAt(this.cost, i).replace(/,/g, "")
        return (digits !== "" && !/^\d+$/.test(digits))
          ? '金額は半角数字のみを用いて入力してください' : ""
      })
    },
    // 内訳(備考)の未入力。見出しは「内訳(備考)」。
    remarks_empty: function () {
      this.remarksEmpty = rowMessages(this.rows, i =>
        textAt(this.remarks, i) === "" ? '内訳(備考)を入力してください ' : "")
    },
    // 内訳(備考)の文字数制限チェック
    remarks_max: function () {
      this.remarksMax = rowMessages(this.rows, i =>
        textAt(this.remarks, i).length > 100
          ? '内訳(備考)は100文字以内で入力してください ' : "")
    },
    // 仮払(事前受取額)の入力形式チェック
    temporary_regex: function () {
      // 見ているのは仮払の欄。「金額」と出すと、隣の金額欄を
      // 直しに行かせてしまう。
      // カンマの扱いは金額と同じ。
      this.temporaryRegex = rowMessages(this.rows, i => {
        const digits = textAt(this.temporary, i).replace(/,/g, "")
        return (digits !== "" && !/^\d+$/.test(digits))
          ? '仮払(事前受取額)は半角数字のみを用いて入力してください' : ""
      })
    },
  }
}
</script>

<style scoped>

</style>
